<template>
    <div class="proList" v-if="indexList.length > 0">
        <div class="container">
            <div class="mainTitle pro"></div>
            <div class="sceTitle">用新的视角遇见更好的自己</div>
            <v-touch class="proList-more" @tap="toMore()">
                <div class="more-type">更多</div>
            </v-touch>
            <div class="pro-top">
                <v-touch @tap="testTap(item)"  class="pro-box" v-for="(item,index) in indexList" :key="index">
                    <div class="pro-box-bg"><img :src="item.introPicture" alt=""></div>
                </v-touch >
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex';
    // import {swiper, swiperSlide, swiperPlugins} from 'vue-awesome-swiper'
    import {cutNum} from '../../../lib/units';

    export default {
        name: 'indexList',
        /*components: {
            swiper,
            swiperSlide
        },*/
        props: [
            'indexList',
            'type',
            'anchorTag'
        ],
        computed: {
            ...mapState([
                'channelId',
            ]),
            isItemDescTwoLine() {
                const that = this;
                let result = 0;
                that.indexList.map(item => {
                    if(item.name.length>8) {
                        result++;
                    }
                })
                return !!(result >0)
            }
        },
        data() {
            return {
                swiper: null,
                swiperSlide: null,
                loadReady: false,
                swiperOption: {
                    autoplay: 0,
                    slidesPerView: 'auto',
                    paginationClickable: true,
                    loop: false,
                    pagination : '.swiper-pagination'
                },
            }
        },
        mounted() {
            if (this.anchorTag != '') {
                let anchorEl = document.querySelector('.indexList.' + this.anchorTag);
                if (anchorEl == undefined) {
                    return;
                } else {
                    document.body.scrollTop = anchorEl.offsetTop;
                }
            }
            ;
        },
        methods: {
            ...mapMutations([
                'setINDEXSCROLLTOP'
            ]),
            cutNum,
            timeTransform(time) {
                if (time == '' | time == undefined) {
                    return ''
                }
                let rs = '';
                let thatDay = new Date(time.replace(/-/g, '/'));
                let today = new Date();
                let c0 = function (num) {
                    return (num * 1) < 10 ? '0' + num : num;
                };
                if ((today.getFullYear() == thatDay.getFullYear()) & (today.getMonth() == thatDay.getMonth()) & (today.getDate() == thatDay.getDate())) {
                    if (today.getHours() == thatDay.getHours()) {
                        return ( c0(today.getMinutes()) - c0(thatDay.getMinutes()) ) + '分钟前';
                    } else {
                        return c0(thatDay.getHours()) + ':' + c0(thatDay.getMinutes());
                    }
                } else {
                    return c0(thatDay.getMonth() + 1) + '-' + c0(thatDay.getDate());
                }
                return rs;
            },
            testTap(testObj) {
                this.$emit('testClick', testObj);
                this.$stat.send({name:'点击首页全面评估',properties:{'测评':testObj.name}});
            },
            toMore(){
                this.$emit('viewMoreSort','全面评估')
            }
        },

        // 如果日后vue-awesome-swiper用的多，可以考虑分离出一个mixins
                // swiper: null,
                // swiperSlide: null,
                // loadReady: false,
        created() {
            domReadyPr.then(() => import('vue-awesome-swiper')).then(({swiper, swiperSlide}) => {
                this.loadReady = true;
                this.swiper = swiper;
                this.swiperSlide = swiperSlide;
            });
        }
    }
</script>

<style lang="scss">
    @import '../../../scss/function';

    @mixin limitLine($line) {
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: $line;
    }

    .proList {
        position: relative;
        overflow: hidden;
        .container {
            margin: topx(40rem) 0 0 topx(40rem);
            position: relative;
        }
        .mainTitle {
            margin-bottom: topx(10rem);
            &.pro {
                width: topx(234rem);
                height: topx(45rem);
                background: url('../../../assets/index/indexTitle_pro.png') no-repeat center;
                background-size: cover;
            }
        }
        .sceTitle {
            margin-bottom: topx(20rem);
            font-size: topx(24rem);
            color: #999999;
            line-height: 1.1;

        }
        .swiper-container {
            margin-left: topx(-10rem);
            // margin-right: topx(20rem);
            .swiper-slide {
                width: topx(670rem);
                border-radius: topx(10rem);
                margin-right: topx(15rem);
                height: topx(180rem);
                overflow: hidden;
                &:first-child {
                    margin-left: topx(0rem);
                }
                &:last-child {
                    margin-right: topx(15rem);
                }
            }
            .swiperCont {
                display: block;
                width: topx(670rem);
                margin: 0    topx(15rem) 0 topx(15rem);
                .imgCont {
                    position: relative;
                    width: topx(180rem);
                    height: topx(180rem);
                    box-sizing: border-box;
                    overflow: hidden;
                    margin-bottom: topx(8rem);
                    border-radius: topx(4rem);
                    img {
                        width: 100%;
                        height: 100%;
                    }
                    .promotion-brand {
                        position: absolute;
                        z-index: 2;
                        top: topx(10rem);
                        left: topx(10rem);
                        width: topx(40rem);
                        height: topx(40rem);
                        background: url('../../../assets/promotion/icon-brand.svg') no-repeat;
                        background-size: cover;
                    }
                    .titleMask {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        opacity: 0.3;
                        background: #000;
                    }

                }
                .desc {
                    font-weight: bold;
                    text-align: left;
                    // @include limitLine(2);
                    font-size: topx(26rem);
                    color: #333333;
                    letter-spacing: 0.13px;
                    line-height: topx(32rem);
                    min-height: topx(64rem);
                    width: topx(188rem);
                }
                .info {
                    overflow: hidden;
                    font-size: 0;
                    margin-top: topx(6rem);
                    .price {
                        float: left;
                        color: #FFA800;
                        line-height: 1;
                        font-weight: bold;
                        &.promotion {
                            color: #FF755B;
                        }
                        &.old-price {
                            margin-left: topx(10rem);
                            text-decoration: line-through;
                            font-size: 10px;
                            color: #999999;
                        }
                    }
                    .right {
                        float: right;
                        font-size: 20px * 0.5;
                        color: #999999;
                        line-height: 28px * 0.5;
                    }
                }
                .testedPeople {
                    font-size: topx(20rem);
                    color: #FFFFFF;
                    line-height: topx(20rem);
                    position: absolute;
                    width: topx(150rem);
                    height: topx(20rem);
                    left: topx(10rem);
                    bottom: topx(10rem);
                }
            }
        }
        .swiper-pagination-bullet-active{
            background: #FFDD2B !important;
        }
        .pro-top{
            overflow: hidden;
            display: flex;
            .pro-box{
                width: topx(325rem);
                height: topx(182rem);
                overflow: hidden;
                border-radius: topx(10rem);
                background: #ccc;
                // margin-right: topx(20rem);
                position: relative;
                margin-right: topx(20rem);
                .pro-box-bg{
                    width: 100%;
                    height: auto;
                    position: absolute;
                    z-index: 0;
                    img{
                        width: 100%;
                        height: auto;
                    }
                }
                .title{
                    font-weight: bold;
                    text-align: center;
                    font-size: topx(28rem);
                    color: #FFFFFF;
                    line-height: topx(28rem);
                    text-shadow: 0 topx(1rem) topx(5rem) rgba(0,0,0,0.30);
                    margin-top: topx(65rem);
                    position: relative;
                    z-index: 1;
                }
                .tis{
                    font-size: topx(24rem);
                    color: #FFFFFF;
                    line-height: topx(24rem);
                    text-shadow: 0 topx(1rem) tox(5rem) rgba(0,0,0,0.30);
                    text-align: center;
                    margin-top: topx(10rem);
                    position: relative;
                    z-index: 1;
                }
            }
        }
        .proList-banner{
            position: relative;
            overflow: hidden;
            .proList-banner-bg{
                position: absolute;
                width: topx(670rem);
                height: topx(180rem);
                background: url('../../../assets/index/index-newtest.png') no-repeat center;
                background-size:100% 100%;
            }
            .proList-title{
                font-size: topx(38rem);
                color: #333333;
                line-height: topx(32rem);
                margin-top: topx(60rem);
                font-weight: bold;
                text-align: center;
                padding-left: topx(200rem);
                width: topx(450rem);
            }
            .proList-desc{
                font-size: topx(24rem);
                color: #999999;
                line-height: topx(20rem);
                margin-top: topx(15rem);
                text-align: center;
                padding-left: topx(200rem);
                width: topx(450rem);
            }
        }
        .proList-more{
            width: topx(80rem);
            height: topx(30rem);
            font-size: topx(28rem);
            color: #333333;
            line-height: topx(28rem);
            position: absolute;
            right: topx(40rem);
            top: topx(15rem);
            .more-type{
                display: inline-block;
                &::after {
                    content: '';
                    width: topx(10rem);
                    height: topx(20rem);
                    background: url('../../../assets/icon/icon_arrow_r.svg') no-repeat center;
                    background-size: cover;
                    margin-left: topx(10rem);
                    display: inline-block;
                };
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/show/index/proSwiper.vue